import * as Constants from "../Data/Constants";
import * as Topics from "../Data/Topics";
import { Button } from "../GameObjects/Button";
import { DebugParameterControls } from "../GameObjects/DebugParameterControls";

export enum BalloonParameter {
    LIFT,
    GRAVITY,
    MIN_SPEED,
    MAX_SPEED,
    HORIZONTAL,
}

export class DebugBalloonControls extends PIXI.Container {
    private _controls: DebugParameterControls[];
    private _visButton: Button;
    private _visible: boolean;

    constructor() {
        super();
        this._visible = true;

        this._controls = new Array<DebugParameterControls>();

        this._controls.push(new DebugParameterControls("Lift: ", BalloonParameter.LIFT, 10, 3000, 10, 100));
        this._controls.push(new DebugParameterControls("Gravity: ", BalloonParameter.GRAVITY, -3000, -10, 10, 100));
        this._controls.push(new DebugParameterControls("Min Spd: ", BalloonParameter.MIN_SPEED, -500, -10, 10, 100));
        this._controls.push(new DebugParameterControls("Max Spd: ", BalloonParameter.MAX_SPEED, 10, 500, 10, 100));
        this._controls.push(new DebugParameterControls("Horiz: ", BalloonParameter.HORIZONTAL, 0, 1000, 10, 100));

        for (let i = 0; i < this._controls.length; ++i) {
            this._controls[i].position.y = i * 65;
            this.addChild(this._controls[i]);
        }

        this._visButton = new Button(this.toggleVis.bind(this), "vis-on", Constants.SPRITESHEET_UI);
        this._visButton.position.set(225, 25);
        this._visButton.scale.set(0.4);
        this.addChild(this._visButton);

        this._controls[BalloonParameter.LIFT].value = 1000;
        this._controls[BalloonParameter.GRAVITY].value = -350;
        this._controls[BalloonParameter.MIN_SPEED].value = -200;
        this._controls[BalloonParameter.MAX_SPEED].value = 200;
        this._controls[BalloonParameter.HORIZONTAL].value = -Constants.PARALLAX_SPEED;

        this.toggleVis();
    }

    private toggleVis(): void {
        this._visible = !this._visible;
        for (let i = 0; i < this._controls.length; ++i) {
            this._controls[i].visible = this._visible;
        }
        // tslint:disable-next-line: no-string-literal
        this._visButton["_image"]!.texture =
            PIXI.loader.resources[Constants.SPRITESHEET_UI].textures![this._visible ? "vis-on" : "vis-off"];
        PubSub.publishSync(this._visible ? Topics.SHOW_DEBUG : Topics.HIDE_DEBUG, undefined);
    }
}
